import { createSelector } from '@ngrx/store';

import {
  ScheduledPaymentBlocksValidationsState,
  ScheduledPaymentFeatureKey,
  ScheduledPaymentState,
  ScheduledPaymentsStore
} from '../reducers';
import { AppState } from '../../../store/state/app.state';

export const selectFeature = ((state: AppState) => state[ScheduledPaymentFeatureKey]);

export const selectScheduledPaymentEntity = createSelector(
  selectFeature,
  (state: ScheduledPaymentsStore) => state.entity
);

export const selectScheduledPaymentList = createSelector(
  selectFeature,
  (state: ScheduledPaymentsStore) => state.list
);

export const selectScheduledPaymentBlocksValidations = createSelector(
  selectFeature,
  (state: ScheduledPaymentsStore) => state.blocksValidations
);

export const selectScheduledPayment = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.scheduledPayment
);

export const selectScheduledPaymentState = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.currentState
);

export const selectScheduledPaymentAttachmentsCount = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.attachmentsCount
);


export const selectCurrencies = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.currencies
);

export const selectPeriods = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.periods
);

export const scheduledPaymentUpdatedAt = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.updatedAt
);

export const isShouldRefresh = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.isShouldRefresh
);

export const loadingRequestsCount = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.loadingRequestsCount
);

export const selectScheduledPaymentSyncPeriods = createSelector(
  selectScheduledPaymentEntity,
  (state: ScheduledPaymentState) => state.syncPeriods
);

export const selectScheduledPaymentPropertiesBlockValid = createSelector(
  selectScheduledPaymentBlocksValidations,
  (state: ScheduledPaymentBlocksValidationsState) => state.propertiesBlockValid
);

export const selectScheduledPaymentBillingInfoBlockValid = createSelector(
  selectScheduledPaymentBlocksValidations,
  (state: ScheduledPaymentBlocksValidationsState) => state.billingInfoBlockValid
);

export const selectScheduledPaymentPositionsBlockValid = createSelector(
  selectScheduledPaymentBlocksValidations,
  (state: ScheduledPaymentBlocksValidationsState) => state.positionsBlockValid
);
